
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/freshdesk",
      function () {
        return require("private-next-pages/destinations/freshdesk.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/freshdesk"])
      });
    }
  